export default __webpack_public_path__ + "static/complete-062954a7a13dbc8bff2ca82ab383af61.webp";